import { BaseService } from "./BaseService";

export const LogService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('log/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos os logs:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`log/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca do Log:', error);
            return false;
        }
    }, 
    async entidades() {
        try {
            return await BaseService.fetchResponseFromAPIPost(`log/entidades`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca das entidades:', error);
            return false;
        }
    }, 
    async store(data) {
        try {
            return BaseService.fetchResponseFromAPIPost(`log`, data);
        } catch (error) {
            console.error('Erro ao salvar configuração:', error);
            throw error;
        }
    } 
}